import styled, { css } from "styled-components";
import PropTypes from "prop-types";

import {
    colors,
    breakpoints,
    spacing2020HasBreakpoints,
    spacing2020WithoutBreakpoints
} from ".";

// h1 - 2XL version:
const H1_2XL_MobileStyle = css`
    font-size: 1.875rem; /* 30px */
`;

const H1_2XL_TabletStyle = css`
    font-size: 2.75rem; /* 44px */
`;

const H1_2XL_DesktopStyle = css`
    font-size: 3.438rem; /* 55px */
`;

export const H1_2XL_New = styled.h1`
    line-height: 125%;

     /* Spacing when one is true, including breakpoints: */
    ${({ SpacingXL }) => SpacingXL && spacing2020HasBreakpoints.SpacingXL}

    /* Mobile: */
    ${H1_2XL_MobileStyle}

    /* Tablet: */
    @media (min-width: ${breakpoints.md}rem) {
        ${H1_2XL_TabletStyle}
    }

    /* Desktop: */
    @media (min-width: ${breakpoints.lg}rem) {
        ${H1_2XL_DesktopStyle}
    }

    /* Screens with 700px - 1000px height range: */
    @media ${breakpoints.laptopHeightsRange} {
        @media (min-width: ${breakpoints.lg}rem) {
            ${H1_2XL_TabletStyle}

            ${({ SpacingXL }) =>
                SpacingXL && spacing2020WithoutBreakpoints.SpacingXLTablet}
        }
    }
`;

// h2 is referred to as "XL" by design sometimes:
const H2MobileStyle = css`
    font-size: 1.625rem; /* 26px*/
`;

const H2TabletStyle = css`
    font-size: 2.188rem; /* 35px*/
`;

const H2DesktopStyle = css`
    font-size: 2.75rem; /* 44px*/
`;

export const H2New = styled.h2`
    display: block;
    text-align: center;
    color: ${colors.black};
    line-height: 125%;

    /* Spacing when one is true, including breakpoints: */
    ${({ Spacing5XL, Spacing4XL }) =>
        Spacing5XL
            ? spacing2020HasBreakpoints.Spacing5XL
            : Spacing4XL
            ? spacing2020HasBreakpoints.Spacing4XL
            : "padding-bottom: 0"};

    /* Mobile: */
    ${H2MobileStyle}

    /* Tablet: */
    @media (min-width: ${breakpoints.md}rem) {
        ${H2TabletStyle}
    }

    /* Desktop: */
    @media (min-width: ${breakpoints.lg}rem) {
        ${H2DesktopStyle}
    }
    

    /* Screens with 700px - 1000px height range: */
    @media ${breakpoints.laptopHeightsRange} {
        @media (min-width: ${breakpoints.lg}rem) {
            ${H2TabletStyle}

            ${({ Spacing5XL, Spacing4XL }) =>
                Spacing5XL
                    ? spacing2020WithoutBreakpoints.Spacing5XLTablet
                    : Spacing4XL
                    ? spacing2020WithoutBreakpoints.Spacing4XLTablet
                    : "padding-bottom: 0"};
        }
    }
`;

H2New.propTypes = {
    Spacing5XL: PropTypes.bool,
    Spacing4XL: PropTypes.bool
};

// h2 - 2XL version:
const H2_2XL_MobileStyle = css`
    font-size: 1.875rem; /* 30px */
`;

const H2_2XL_TabletStyle = css`
    font-size: 2.75rem; /* 44px */
`;

const H2_2XL_DesktopStyle = css`
    font-size: 3.438rem; /* 55px */
`;

export const H2_2XL_New = styled.h2`
    line-height: 125%;

     /* Spacing when one is true, including breakpoints: */
    ${({ SpacingXL }) => SpacingXL && spacing2020HasBreakpoints.SpacingXL}

    /* Mobile: */
    ${H2_2XL_MobileStyle}

    /* Tablet: */
    @media (min-width: ${breakpoints.md}rem) {
        ${H2_2XL_TabletStyle}
    }

    /* Desktop: */
    @media (min-width: ${breakpoints.lg}rem) {
        ${H2_2XL_DesktopStyle}
    }

    /* Screens with 700px - 1000px height range: */
    @media ${breakpoints.laptopHeightsRange} {
        @media (min-width: ${breakpoints.lg}rem) {
            ${H2_2XL_TabletStyle}

            ${({ SpacingXL }) =>
                SpacingXL && spacing2020WithoutBreakpoints.SpacingXLTablet}
        }
    }
`;

// h4 is referred to as "MD" by design sometimes:
const H4MobileStyle = css`
    font-size: 1.25rem; /* 20px */
    line-height: 160%;
`;

const H4TabletStyle = css`
    font-size: 1.375rem; /* 22px */
    line-height: 125%;
`;

const H4DesktopStyle = css`
    font-size: 1.75rem; /* 28px*/
    line-height: 125%;
`;

export const H4New = styled.h5`
    /* Mobile: */
    ${H4MobileStyle}

     /* Tablet: */
     @media (min-width: ${breakpoints.md}rem) {
        ${H4TabletStyle};
    }
     /* Desktop: */
    @media (min-width: ${breakpoints.lg}rem) {
        ${H4DesktopStyle};
    }

    /* Screens with 700px - 1000px height range: */
    @media ${breakpoints.laptopHeightsRange} {
        @media (min-width: ${breakpoints.lg}rem) {
            ${H4TabletStyle}
        }
    }
`;

// h5 is referred to as "SM" by design sometimes:
const H5MobileAndTabletStyle = css`
    font-size: 1.125rem; /*18px*/
    line-height: 150%;
`;

const H5DesktopStyle = css`
    font-size: 1.438rem; /* 23px*/
    line-height: 125%;
`;

export const H5New = styled.h5`
    /* Mobile + Tablet: */
    ${H5MobileAndTabletStyle}

     /* Desktop: */
    @media (min-width: ${breakpoints.lg}rem) {
        ${H5DesktopStyle};
    }

    /* Screens with 700px - 1000px height range: */
    @media ${breakpoints.laptopHeightsRange} {
        @media (min-width: ${breakpoints.lg}rem) {
            ${H5MobileAndTabletStyle}
        }
    }
`;

// h6 is referred to as "XS" by design sometimes:
const H6MobileAndTabletStyle = css`
    font-size: 1rem; /*16px*/
    line-height: 150%;
`;

const H6DesktopStyle = css`
    font-size: 1.125rem; /*18px*/
    line-height: 160%;
`;

export const H6New = styled.h6`
    /* Mobile + Tablet: */
    ${H6MobileAndTabletStyle}

    /* Desktop +: */
    @media (min-width: ${breakpoints.lg}rem) {
        ${H6DesktopStyle}
    }

    /* Screens with 700px - 1000px height range: */
    @media ${breakpoints.laptopHeightsRange} {
        @media (min-width: ${breakpoints.lg}rem) {
            ${H6MobileAndTabletStyle}
        }
    }
`;
